import React from 'react';
import Layout from '../components/Layout/Layout';
import "../styles/Contact.css";

const Contact = () => {
  return (
    <Layout title={'تواصل معنا - النخبة ستور'}>
      {/* Hero */}
      <div className="contact-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="contact-hero-bg" />
        <div className="contact-hero-overlay">
          <h1>تواصل معنا</h1>
          <p>نحن هنا لخدمتك على مدار الساعة</p>
        </div>
      </div>

      {/* Contact Info Cards */}
      <div className="container contact-info-section">
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <div className="contact-info-card">
              <div className="contact-icon">📍</div>
              <h5>العنوان</h5>
              <p>العراق - بغداد<br/>شارع المنصور</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="contact-info-card">
              <div className="contact-icon">📞</div>
              <h5>الهاتف</h5>
              <p>00971542237463</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="contact-info-card">
              <div className="contact-icon">✉️</div>
              <h5>البريد الإلكتروني</h5>
              <p>info@alnakhba-store.shop<br/>support@alnakhba-store.shop</p>
            </div>
          </div>
        </div>
      </div>

      {/* Map */}
      <iframe title="موقع النخبة ستور" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.5!2d44.3661!3d33.3128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDE4JzQ2LjEiTiA0NMKwMjEnNTcuOSJF!5e0!3m2!1sar!2siq!4v1712335689663!5m2!1sar!2siq"
        width="100%"
        height={400}
        style={{border: 0, filter:'brightness(0.8) contrast(1.1)'}}
        allowFullScreen loading="lazy"
        referrerPolicy="no-referrer-when-downgrade" />

      {/* Contact Form */}
      <div className='container'>
        <div className='contact-form'>
          <h3 className="contact-form-title">أرسل لنا رسالة</h3>
          <form action='https://formspree.io/f/mjvnpvre' method='post' className='contact-inputs'>
            <input type='text' name='username' placeholder='الاسم الكامل' autoComplete='off' required className='uname'></input>
            <input type='email' name='email' placeholder='البريد الإلكتروني' autoComplete='off' required className='emailfield'></input>
            <textarea name='message' cols={20} rows={5} autoComplete='off' required className='textareafield' placeholder='اكتب رسالتك هنا...'>
            </textarea>
            <input type='submit' value={"إرسال الرسالة"} className='btn-submit'></input>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
